import { notification } from 'antd';
import React, { useEffect, useMemo } from 'react'
import useGeneralStore from '../../Store/generalStore';
import useOnlineStatus from '../../Config/hooks/useOnlineStatus';

const Context = React.createContext({
    name: 'Default',
});

const Toast = () => {

    const { message, error, info, toastTick, setError, setMessage, setInfo } = useGeneralStore(state => state);
    const [api, contextHolder] = notification.useNotification();
    const isOnline = useOnlineStatus()

    const openNotification = (placement, type = 'info', msg, key) => {
        const description = <Context.Consumer>{() => `${msg}`}</Context.Consumer>;

        const common = {
            description,
            placement,
            key,
            duration: 4.5,
            zIndex: 4000, // above Ant Design Modal (1000+) so auth errors are visible
        };

        if (type === 'success') {
            api.success({
                message: 'Success',
                ...common,
            });
        } else if (type === 'error') {
            api.error({
                message: 'Error',
                ...common,
            });
        } else if (type === 'info') {
            api.info({
                message: 'Info',
                ...common,
            });
        }
    };

    useEffect(() => {
        if (!isOnline) {
            openNotification('topRight', 'info', 'No internet connection', `offline-${Date.now()}`)
        }
    }, [isOnline])

    useEffect(() => {
        if (!toastTick) {
            return undefined;
        }

        const notificationKey = `toast-${toastTick}`;

        if (message) {
            openNotification('topRight', 'success', message, `${notificationKey}-success`);
        }
        if (error) {
            openNotification('topRight', 'error', error, `${notificationKey}-error`);
        }
        if (info) {
            openNotification('topRight', 'info', info, `${notificationKey}-info`);
        }

        if (!message && !error && !info) {
            return undefined;
        }

        const timer = setTimeout(() => {
            setMessage('');
            setError('');
            setInfo('');
        }, 100);

        return () => clearTimeout(timer);
    }, [toastTick, message, error, info, setMessage, setError, setInfo])

    const contextValue = useMemo(
        () => ({
            name: 'Ant Design',
        }),
        [],
    );

    return (
        <Context.Provider value={contextValue}>
            {contextHolder}
        </Context.Provider>

    )
}

export default Toast
